import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import './Portfolio.css';
import gnBgImg from '../../assets/images/backgrounds/Gold-Nutrition.jpg';
import gnLogoImg from '../../assets/images/logos/Gold-Nutrition.png';
import mrBgImg from '../../assets/images/backgrounds/Metrex.jpg';
import mrLogoImg from '../../assets/images/logos/Metrex.png';
import cfBgImg from '../../assets/images/backgrounds/Ceasefire.jpg';
import cfLogoImg from '../../assets/images/logos/Ceasefire.png';
import snBgImg from '../../assets/images/backgrounds/Snips.jpg';
import snLogoImg from '../../assets/images/logos/Snips.png';
import cpBgImg from '../../assets/images/backgrounds/Capital-Plus.jpg';
import cpLogoImg from '../../assets/images/logos/Capital-Plus.png';
import cbBgImg from '../../assets/images/backgrounds/ConnectBooks.jpg';
import cbLogoImg from '../../assets/images/logos/ConnectBooks.png';
import aaBgImg from '../../assets/images/backgrounds/Approvall.jpg';
import aaLogoImg from '../../assets/images/logos/Approvall.png';
import ezBgImg from '../../assets/images/backgrounds/EZ-Energy.jpg';
import ezLogoImg from '../../assets/images/logos/EZ-Energy.png';
import liBgImg from '../../assets/images/backgrounds/Lease-it.jpg';
import liLogoImg from '../../assets/images/logos/Lease-it.png';
import lcBgImg from '../../assets/images/backgrounds/Le-Chapeau.jpg';
import lcLogoImg from '../../assets/images/logos/Le-Chapeau.png';
import frBgImg from '../../assets/images/backgrounds/Fulfillrite.jpg';
import frLogoImg from '../../assets/images/logos/Fulfillrite.png';
import enbBgImg from '../../assets/images/backgrounds/ENB.jpg';
import enbLogoImg from '../../assets/images/logos/ENB.png';
import p15BgImg from '../../assets/images/backgrounds/Plaza-15.jpg';
import p15LogoImg from '../../assets/images/logos/Plaza-15.png';
import cvBgImg from '../../assets/images/backgrounds/Converge-Funding.jpg';
import cvLogoImg from '../../assets/images/logos/Converge-Funding.png';
import ucBgImg from '../../assets/images/backgrounds/U-Capture.jpg';
import ucLogoImg from '../../assets/images/logos/U-Capture.png';
import msBgImg from '../../assets/images/backgrounds/Maven.jpg';
import msLogoImg from '../../assets/images/logos/Maven.png';
import exBgImg from '../../assets/images/backgrounds/Credit.jpg';
import exLogoImg from '../../assets/images/logos/Credit.png';
import meBgImg from '../../assets/images/backgrounds/Metrex-Equities.jpg';
import meLogoImg from '../../assets/images/logos/Metrex-Equities.png';
import bpBgImg from '../../assets/images/backgrounds/Braun.jpg';
import bpLogoImg from '../../assets/images/logos/Braun.png';
import zsBgImg from '../../assets/images/backgrounds/ZazoSell.jpg';
import zsLogoImg from '../../assets/images/logos/ZazoSell.png';
import bbBgImg from '../../assets/images/backgrounds/Betterbow.jpg';
import bbLogoImg from '../../assets/images/logos/Betterbow.png';
import tfBgImg from '../../assets/images/backgrounds/Taubers-fish.jpg';
import tfLogoImg from '../../assets/images/logos/Taubers-fish.png';
import ptBgImg from '../../assets/images/backgrounds/Personalized-Trends.jpg';
import ptLogoImg from '../../assets/images/logos/Personalized-Trends.png';
import bhBgImg from '../../assets/images/backgrounds/B_H.jpg';
import bhLogoImg from '../../assets/images/logos/B_H.png';
import spBgImg from '../../assets/images/backgrounds/Skilled.jpg';
import spLogoImg from '../../assets/images/logos/Skilled.png';
import nyfBgImg from '../../assets/images/backgrounds/NYF.jpg';
import nyfLogoImg from '../../assets/images/logos/NYF.png';
import ugBgImg from '../../assets/images/backgrounds/Upgrades.jpg';
import ugLogoImg from '../../assets/images/logos/Upgrades.png';

import spendlessBgImg from '../../assets/images/backgrounds/Spendless.jpg';
import spendlessLogoImg from '../../assets/images/logos/Spendless.png';

import abBgImg from '../../assets/images/backgrounds/ABfloors.jpg';
import abLogoImg from '../../assets/images/logos/ABfloor.png';

import amBgImg from '../../assets/images/backgrounds/Am_Judaica.jpg';
import amLogoImg from '../../assets/images/logos/AM.png';

import megBgImg from '../../assets/images/backgrounds/Meglio.jpg';
import megLogoImg from '../../assets/images/logos/Meglio.png';

import prsBgImg from '../../assets/images/backgrounds/PromoSpot.jpg';
import prsLogoImg from '../../assets/images/logos/promospot.png';

import ttchBgImg from '../../assets/images/backgrounds/tetech.jpg';
import ttchLogoImg from '../../assets/images/logos/Tetech.png';

class Portfolio extends Component {
  state = {
    data: [
      {
        name: 'gold nutrition clinic',
        backgroundImage: gnBgImg,
        logoImage: gnLogoImg,
        categories: ['logo', 'branding']
      },
      {
        name: 'metrex realty',
        backgroundImage: mrBgImg,
        logoImage: mrLogoImg,
        categories: ['web design', 'marketing']
      },
      {
        name: 'cease fire',
        backgroundImage: cfBgImg,
        logoImage: cfLogoImg,
        categories: ['web design']
      },
      {
        name: 'snips',
        backgroundImage: snBgImg,
        logoImage: snLogoImg,
        categories: ['logo', 'branding']
      },
      {
        name: 'capital plus',
        backgroundImage: cpBgImg,
        logoImage: cpLogoImg,
        categories: ['web design']
      },
      {
        name: 'connect books',
        backgroundImage: cbBgImg,
        logoImage: cbLogoImg,
        categories: ['ux - ui design']
      },
      {
        name: 'approveall',
        backgroundImage: aaBgImg,
        logoImage: aaLogoImg,
        categories: ['web design']
      },
      {
        name: 'ez energy',
        backgroundImage: ezBgImg,
        logoImage: ezLogoImg,
        categories: ['ux - ui design']
      },
      {
        name: 'lease it',
        backgroundImage: liBgImg,
        logoImage: liLogoImg,
        categories: ['logo', 'marketing']
      },
      {
        name: 'le chapeau',
        backgroundImage: lcBgImg,
        logoImage: lcLogoImg,
        categories: ['logo', 'branding']
      },
      {
        name: 'fulfillrite',
        backgroundImage: frBgImg,
        logoImage: frLogoImg,
        categories: ['web design']
      },
      {
        name: 'enb phones',
        backgroundImage: enbBgImg,
        logoImage: enbLogoImg,
        categories: ['ux - ui design']
      },
      {
        name: 'plaza 15 storage',
        backgroundImage: p15BgImg,
        logoImage: p15LogoImg,
        categories: ['logo', 'branding']
      },
      {
        name: 'converge funding',
        backgroundImage: cvBgImg,
        logoImage: cvLogoImg,
        categories: ['logo', 'branding']
      },
      {
        name: 'u capture',
        backgroundImage: ucBgImg,
        logoImage: ucLogoImg,
        categories: ['logo', 'marketing']
      },
      {
        name: 'maven software',
        backgroundImage: msBgImg,
        logoImage: msLogoImg,
        categories: ['logo', 'branding']
      },
      {
        name: 'excore',
        backgroundImage: exBgImg,
        logoImage: exLogoImg,
        categories: ['ui - ux design']
      },
      {
        name: 'metrex equities',
        backgroundImage: meBgImg,
        logoImage: meLogoImg,
        categories: ['logo', 'branding']
      },
      {
        name: ' Braun p&h',
        backgroundImage: bpBgImg,
        logoImage: bpLogoImg,
        categories: ['logo design']
      },
      {
        name: 'zazo sell',
        backgroundImage: zsBgImg,
        logoImage: zsLogoImg,
        categories: ['ux - ui design']
      },
      {
        name: 'better bow',
        backgroundImage: bbBgImg,
        logoImage: bbLogoImg,
        categories: ['logo', 'branding']
      },
      {
        name: 'taubers fish',
        backgroundImage: tfBgImg,
        logoImage: tfLogoImg,
        categories: ['logo', 're-branding']
      },
      {
        name: 'personalized trends',
        backgroundImage: ptBgImg,
        logoImage: ptLogoImg,
        categories: ['branding', 'marketing']
      },
      {
        name: 'b&h photo',
        backgroundImage: bhBgImg,
        logoImage: bhLogoImg,
        categories: ['ux - ui design']
      },
      {
        name: 'skilled pest control',
        backgroundImage: spBgImg,
        logoImage: spLogoImg,
        categories: ['marketing']
      },
      {
        name: 'NYF',
        backgroundImage: nyfBgImg,
        logoImage: nyfLogoImg,
        categories: ['ux - ui design']
      },
      {
        name: 'upgrade',
        backgroundImage: ugBgImg,
        logoImage: ugLogoImg,
        categories: ['marketing']
      },
      //
      {
        name: 'AM Judaica',
        backgroundImage: amBgImg,
        logoImage: amLogoImg,
        categories: ['Pdoduct design']
      },
      {
        name: 'spendless',
        backgroundImage: spendlessBgImg,
        logoImage: spendlessLogoImg,
        categories: ['logo', 'branding']
      },
      {
        name: 'promo spot',
        backgroundImage: prsBgImg,
        logoImage: prsLogoImg,
        categories: ['web design']
      },
      {
        name: 'tetech',
        backgroundImage: ttchBgImg,
        logoImage: ttchLogoImg,
        categories: ['logo', 'web design']
      },
      {
        name: 'meglio',
        backgroundImage: megBgImg,
        logoImage: megLogoImg,
        categories: ['logo', 'branding']
      },
      {
        name: 'ab floors',
        backgroundImage: abBgImg,
        logoImage: abLogoImg,
        categories: ['marketing']
      }
    ]
  };
  render() {
    return (
      <div className="prot_wrpr">
        <div className="prot_hdr">
          <div className="prot_hdr_innr">
            <Link to="/home">
              <div className="ib logo_wrpr" />
            </Link>
          </div>
        </div>
        <div className="cntnt_wrpr">
          <div className="innr_wrpr">
            {this.state.data.map(itm => (
              <div className="ib item_wrpr">
                <div className="df  itm_logo_wrpr">
                  <img src={itm.logoImage} />
                </div>
                <div
                  className="img"
                  style={{ backgroundImage: `url(${itm.backgroundImage})` }}
                />
                <p className="df itm_ttl">
                  {itm.categories.map(cat => (
                    <span>{cat}</span>
                  ))}
                </p>
              </div>
            ))}
            {/* <div className="ib item_wrpr">
              <div className="img li" />
            </div>
            <div className="ib item_wrpr">
              <div className="img mg" />
            </div>
            <div className="ib item_wrpr">
              <div className="img lc" />
            </div>
            <div className="ib item_wrpr">
              <div className="img tt" />
            </div>
            <div className="ib item_wrpr">
              <div className="img bba" />
            </div>
            <div className="ib item_wrpr">
              <div className="img ms" />
            </div>
            <div className="ib item_wrpr">
              <div className="img ab" />
            </div>
            <div className="ib item_wrpr">
              <div className="img mc" />
            </div>
            <div className="ib item_wrpr">
              <div className="img bb" />
            </div>
            <div className="ib item_wrpr">
              <div className="img pe" />
            </div>
            <div className="ib item_wrpr">
              <div className="img mr" />
            </div>
            <div className="ib item_wrpr">
              <div className="img tbc" />
            </div>
            <div className="ib item_wrpr">
              <div className="img zzc" />
            </div>
            <div className="ib item_wrpr">
              <div className="img admcli " />
            </div>
            <div className="ib item_wrpr">
              <div className="img admckiki " />
            </div>
            <div className="ib item_wrpr">
              <div className="img omedia " />
            </div>
            <div className="ib item_wrpr">
              <div className="img tbf" />
            </div>
            <div className="ib item_wrpr">
              <div className="img tbfl " />
            </div>
            <div className="ib item_wrpr">
              <div className="img bphp " />
            </div>
            <div className="ib item_wrpr">
              <div className="img bphl " />
            </div>
            <div className="ib item_wrpr">
              <div className="img rbcsn" />
            </div>
            <div className="ib item_wrpr">
              <div className="img ycptr" />
            </div>
            <div className="ib item_wrpr">
              <div className="img mtrxf" />
            </div> */}
            {/* <div className="ib item_wrpr">
              <div className="img prsnti " />
            </div> */}
          </div>
        </div>
      </div>
    );
  }
}

export default Portfolio;



// WEBPACK FOOTER //
// ./src/components/protifolio-collection/Portfolio.js